import {
  avisGoogleMock,
  cartesDynamiquesMock,
  heroComponentMock,
  promesseMock,
  spacerMock,
  stickerTexteMock,
  texteSeoVisuelBasMock,
} from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [
  heroComponentMock,
  cartesDynamiquesMock,
  promesseMock,
  spacerMock(),
  stickerTexteMock(true),
  avisGoogleMock(),
  texteSeoVisuelBasMock,
];

export const homepageMock: SlugPage = {
  ...pageBase({
    title: 'Accueil',
    type: 'homepage',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: true,
  }),
  blocks,
};
